<template>
	<el-dialog :visible.sync="show"
		:title="$t('privateNetwork.delTitle')"
		:close-on-click-modal="false"
		:before-close="handleClose"
		class="del-root">
		<el-section class="i-text" v-if="ipv6Cidr">
	        <div v-if="ipv6Cidr" class="tip-warning mb20 lh20"
	            v-html="$t('privateNetwork.delPrivateNetworkTip')">
	        </div>
      	</el-section>
		<p>{{ $t('privateNetwork.delConfirm', [vpcName]) }}</p>
		<div slot="footer" class="dialog-footer">
			<el-button @click="cancelDel">{{ $t('privateNetwork.cancel') }}</el-button>
			<el-button @click="sureDel" type="primary">{{ $t('privateNetwork.sure') }}</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: 'DelPrivateSub',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		vpcName: {
			type: String,
			default: ''
		},
		vpcId: {
			type: String,
			default: ''
		},
		region: {
			type: String,
			default: ''
		},
		ipv6Cidr: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			show: false
		};
	},
	watch: {
		visible(newVal) {
			this.show = newVal;
		}
	},
	methods: {
		handleClose() {
			this.show = false;
			this.$emit('update:visible', false);
		},
		cancelDel() {
			this.handleClose();
		},
		sureDel() {
			const params = {
				region: this.region,
				vpcId: this.vpcId
			};
			Ajax.del('/api/cps/vpcs', params)
			.then((res) => {
				this.$emit('refresh');
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch(ex) {
					console.log(ex);
				}
			})
			.finally(() => {
				this.handleClose();
			});
		}
	},
};
</script>

<style lang="scss">
	@import "delPrivate";
</style>



// WEBPACK FOOTER //
// src/components/privateNetwork/delPrivateSub/DelPrivateSub.vue